import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'partnerEdit.breadcrumb.home',
    defaultMessage: 'Home',
  },
  partnerManagement: {
    id: 'partnerEdit.breadcrumb.partnerManagement',
    defaultMessage: 'Partner Management',
  },
  partnerDetail: {
    id: 'partnerEdit.breadcrumb.partnerDetail',
    defaultMessage: 'Detail',
  },
  partnerEdit: {
    id: 'partnerEdit.breadcrumb.partnerEdit',
    defaultMessage: 'Edit',
  },
  stepOneTitle: {
    id: 'partnerEdit.stepOne.title',
    defaultMessage: 'Basic Information',
  },
  stepOneDescription: {
    id: 'partnerEdit.stepOne.description',
    defaultMessage: 'Basic information detail of selected partner',
  },
  stepOnePageTitle: {
    id: 'partnerEdit.stepOne.pageTitle',
    defaultMessage: 'Partner Basic Information Details',
  },
  stepTwoTitle: {
    id: 'partnerEdit.stepTwo.title',
    defaultMessage: 'Service Information',
  },
  stepTwoDescription: {
    id: 'partnerEdit.stepTwo.description',
    defaultMessage:
      'Basic information details about service for related partner',
  },
  stepTwoPageTitle: {
    id: 'partnerEdit.stepTwo.pageTitle',
    defaultMessage: 'Service Basic Information Details',
  },
  stepThreeTitle: {
    id: 'partnerEdit.stepThree.title',
    defaultMessage: 'Package Type',
  },
  stepThreeDescription: {
    id: 'partnerEdit.stepThree.description',
    defaultMessage: 'Package type description for each related service',
  },
  stepThreePageTitle: {
    id: 'partnerEdit.stepThree.pageTitle',
    defaultMessage: 'Service Package Type Description',
  },
  packageTypePlaceholder: {
    id: 'partnerEdit.packageType.placeholder',
    defaultMessage:
      'Enter your package type description, ex:\n- Maximum weight is 8kg\n- Maximum distance is 25km',
  },
});
